module.exports = __webpack_public_path__ + "static/img/state4.478acd00.png";